/** @format */

import React from "react";
import { Box } from "@mui/material";
import ChatMessage from "./ChatMessage";
import EmptyState from "./EmptyState";
import LoadingSkeleton from "./LoadingSkeleton";

const ChatThread = ({
  turns,
  isFetching,
  analyzingTurn,
  onPromptClick,
  onSuggestion,
  onAnalyze,
  onFeedback,
  isReady,
  userName,
  analytics,
  analyticsLoading,
  merchantFacts,
  sessionId,
}) => {
  const scrollRef = React.useRef(null);

  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [turns, isFetching]);

  const isEmpty = turns.length === 0;
  const lastTurn = turns[turns.length - 1];
  const showSkeleton =
    isFetching && (!lastTurn || lastTurn.bot === null) ? true : false;

  return (
    <Box
      ref={scrollRef}
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        backgroundColor: "#f1f5f9",
        "&::-webkit-scrollbar": { width: 8 },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#cbd5e1",
          borderRadius: 4,
        },
        "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
      }}
    >
      {isEmpty ? (
        <EmptyState
          onPromptClick={onPromptClick}
          disabled={!isReady}
          userName={userName}
          analytics={analytics}
          analyticsLoading={analyticsLoading}
          merchantFacts={merchantFacts}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            py: 2,
            // Use the full width on laptops but cap line length on ultrawide.
            maxWidth: 980,
            mx: "auto",
            width: "100%",
          }}
        >
          {turns.map((t, i) => (
            <ChatMessage
              key={t.id}
              turn={t}
              turnIndex={i}
              onSuggestion={onSuggestion}
              onAnalyze={onAnalyze}
              onFeedback={onFeedback}
              isAnalyzing={analyzingTurn === i}
              isFetching={isFetching}
              sessionId={sessionId}
            />
          ))}
          {showSkeleton && <LoadingSkeleton question={lastTurn?.user} />}
        </Box>
      )}
    </Box>
  );
};

export default ChatThread;
